module.exports = __webpack_public_path__ + "media/customize/banner-stack-top-5037faf8.svg";